import PropTypes from 'prop-types';
import React from 'react';

export const modalSizes = {
  small: 'modal-sm',
  large: 'modal-lg',
  default: '',
};

class Modal extends React.Component {
  static displayName = 'Modal';

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    children: PropTypes.any,
    size: PropTypes.string,
    width: PropTypes.number,
    className: PropTypes.string,
    hideCloseButton: PropTypes.bool,
    headerImage: PropTypes.string,
    headerText: PropTypes.string,
  };

  componentWillMount() {
    document.querySelector('body').addEventListener('click', this.clickHandler);
    document.querySelector('body').addEventListener('keydown', this.keyHandler);
  }

  componentWillUnmount() {
    document.querySelector('body').removeEventListener('click', this.clickHandler);
    document.querySelector('body').removeEventListener('keydown', this.keyHandler);
  }

  getDefaultPropTypes = () => {
    return {
      size: modalSizes.default,
    };
  };

  clickHandler = (e) => {
    if (!e.target.closest('.modal-dialog')) {
      this.props.onClose();
    }
  };

  keyHandler = (e) => {
    if (e.keyCode === 27) {
      this.props.onClose();
    }
  };



  render() {
    let {width, hideCloseButton, onClose, size, className, children, headerText, headerImage} = this.props;
    let style = width ? {width: width} : {};
    let showHeader = !!headerText || !!headerImage;
    let showCloseHeader;



    if (hideCloseButton) {
      showCloseHeader = null;
    } else {
      showCloseHeader = <div className='modal-close-header'>
        <i className='bl bl-delete modal-close-button' onClick={onClose} />
      </div>;
    }
    return <div className={`modal-backdrop ${className ?  className : ''}`}>
      <div className='modal' style={{display: 'block'}}>
        <div className={'modal-dialog ' + size} style={style}>
          {showCloseHeader}
          <div className='modal-content' >
            {showHeader ? <div className="modal-header modal-header-custom">
              {headerText ? headerText : null}
              {headerImage ? <img src={headerImage}/> : null}
            </div> : null}
            <div className="modal-body" style={showHeader ? {maxHeight: 'calc(80vh - 90px)'} : {}}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}

export default Modal;
